import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';


/**
 * APIL Url: ADAC.Internet.Core.Models.Zahlungsweisen.PreAuthorizeRequestModel
 * Model für die Anfrage der Generierung des Hashs für die Zahlungsauthorisierung
 * Endpoints: /api/Zahlungsweisen/payone
 */
export class PreAuthorizeRequestModelApi extends BaseApiModel {
	constructor(initialProperties?: Partial<PreAuthorizeRequestModelApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected betrag: string;
	/**
	 * Description: der Betrag
	 * APIL Type: string
	 */
	get Betrag(): string {
		return this.betrag;
	}

	/**
	 * Description: der Betrag
	 * APIL Type: string
	 */
	set Betrag(value: string) {
		this.betrag = value;
	}

	protected backurl: string;
	/**
	 * Description: backurl
	 * APIL Type: string
	 */
	get Backurl(): string {
		return this.backurl;
	}

	/**
	 * Description: backurl
	 * APIL Type: string
	 */
	set Backurl(value: string) {
		this.backurl = value;
	}

	protected errorurl: string;
	/**
	 * Description: errorurl
	 * APIL Type: string
	 */
	get Errorurl(): string {
		return this.errorurl;
	}

	/**
	 * Description: errorurl
	 * APIL Type: string
	 */
	set Errorurl(value: string) {
		this.errorurl = value;
	}

	protected successurl: string;
	/**
	 * Description: successurl
	 * APIL Type: string
	 */
	get Successurl(): string {
		return this.successurl;
	}

	/**
	 * Description: successurl
	 * APIL Type: string
	 */
	set Successurl(value: string) {
		this.successurl = value;
	}

	protected proccessId: number;
	/**
	 * Description: ProccessId
	 * APIL Type: int64
	 */
	get ProccessId(): number {
		return this.proccessId;
	}

	/**
	 * Description: ProccessId
	 * APIL Type: int64
	 */
	set ProccessId(value: number) {
		this.proccessId = value;
	}

	protected reference: string;
	/**
	 * Description: Reference
	 * APIL Type: string
	 */
	get Reference(): string {
		return this.reference;
	}

	/**
	 * Description: Reference
	 * APIL Type: string
	 */
	set Reference(value: string) {
		this.reference = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): PreAuthorizeRequestModelApi {
		return AppUtils.Helper.createFromMap(dataObject, PreAuthorizeRequestModelApi, (key, value) => {
			switch (key.toLowerCase()) {

				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.Betrag = this.betrag;
		result.Backurl = this.backurl;
		result.Errorurl = this.errorurl;
		result.Successurl = this.successurl;
		result.ProccessId = this.proccessId;
		result.Reference = this.reference;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}